let config =
{
    dev_mode: false, // If true, anyone will be able to acccess the admin panel regardless of IP address
    enable_purchasing: true,
    domain: "www.shop.abcchs.com.au",
    web_url: `https://www.shop.abcchs.com.au/`,
    website_port: 3000,
    admin_port: 3001,
    admin_ip: "43.247.65.64",
    brand_id: 1,
    brand_name: "ABC Container Hire & Sales",
    brand_name_abbrev: "ABC",
    email_domain: "abcchs.com.au",
    tel: "1300222266",
    tel_text: "1300 22 22 66",
    web_email_from: `website@abcchs.com.au`,
    recaptcha_secret: "6LfYtcQnAAAAAKHRrGn4jsuHQn3U9uGvZsOnLv6L",
    db_connection: {
        host: '172.26.5.113',
        port: 1433,
        user: 'public_websites_ro',
        password: '#8F48ZDhRXy^',
        database: 'abcchs_shop_public'
    },
    admin_db_connection: {
        host: '172.26.5.113',
        port: 1433,
        user: 'public_websites_rw',
        password: 'cBSKl845jV%c',
        database: 'abcchs_shop_public'
    },
    public_sites_db_connection: {
        host: '172.26.5.113',
        port: 1433,
        user: 'public_websites_rw',
        password: 'cBSKl845jV%c',
        database: 'public_websites'
    },
    max_cart_items: 5,
    disable_same_cart_items: true,
    google_client_secret: "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",
    google_client_id: "758203465075-70t8d1k7ko3d14gje0cbnr3nt3uor9df.apps.googleusercontent.com",
    google_refresh_token: "1//04ZO6uzM3QqGICgYIARAAGAQSNwF-L9IrlO1mDAI9771uCJPsI8mSkPtlALp1ob2Gnor7Qqo9YhCKO6lrMVQ1lIINCh4KyMzSR1I",
    google_service_client_email: "sckcontentsa@email-signatures-347022.iam.gserviceaccount.com",
    google_service_private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQC2JwdZ4fROP5rG\n07TxigzoZqOfta3jPocuEXWK/va9KsLjKMxU7dD/qTfnxC11saXgeQ2JMGSrgkme\n1jOAEWQ0biarRzLCG2tnp3tGt9zO2ZS3nW8Hb6UTYtaBkij0tCI6cB0TjtWPIQZT\nfh7EGjqYcMvCeuXITxXuvGrktTUfcV9SxVagNZqNLJoufX4GLP4LisxBN0uvlwS8\nYtYC3GJ/k2vJIHkbFKJeVRUCK86caIpti6/ulrL6TKqdHZYIByHyOlRw5j96RIn/\nwtqPF32BR8mk5bBhtm1NINnnyZ5CNjkXPh9JtyP+RuqQpc3KVE73u1bJ3CTJTgOQ\ncFRMHzBNAgMBAAECggEAAL4YUmj7O9BtkJmaAhFmgRIItmTMCyzyPyFUwdbNPwiB\nbTdO3JpwQNfklvNz81K16Dwww8TokXxr/BOdIndaWbkIkP0u0J9s/ioEH3iDaW0g\npT5P5A9enxLG6MClncMYOqBsteuIpQHk9TUtP0O+G737Tqp9QlD0OBoY3iAmUcpS\nQZs8HRa5636vdU6d/yoNnQTItWzJH/3RbnAjKLpR/zROZrX/16SOZk2h3wboOjxO\nGpTGByHyrjUdiPSRJv7A5RqiWRueiVHq3MqBCPBtlJeNkg/huouiNGgXzuokvMvA\n+DTqmTHP7frxU7E+J9/dJSx/T4hMJlScNHbpGjrSsQKBgQDwuw29YpWlAFUnF3/W\ne3Sc86qChjpp9J0C3vzl3xNZ9N8X/2kdvgqoueOan7Jcm7r8nLazp/dez8yaVS14\nfaoOYyruRR9QRabQucWVe/JQUuHu04r1PfMUdiYFLfnrUldtIBqMKcQFSfiC03us\n1faAKCqp7CW08OMu20goy1w+uQKBgQDBtMqNRcNnhjFn6wA86V/1Yt/AMA3DHynU\n5zvX/phE4pGSNuMQU9+dJpGSBwTHoAcj4jJ3LO8J6n8IY08IuEmywdEpaZzLfaS8\nRIUunIXvrWRC/fTiBEY4s493Sy9foaAZdUCB7jVvti9yyd+xsMtX9R4vUB1E7Epg\nsYhnvD3UNQKBgBXkbPN0K7e9uAC+GlofEBPV9QO5wUYxgLXqIYWmK9RaeI9uItkZ\nl06Q2SoOq+HQJ8khV1wvQkfVDf5bEK+MfhKg4h6ZGqfqLal9u4JEq1yyrOlTQ6fZ\n4mlR9VMzQy8rZdf+u2tTwQfaGkeLhAvLyYcOIBMj7qnt3js8petP0yvBAoGAEd65\n6PqMolpQ6INXjEcDYUHz3mkQe/W+CDQk4zJLnd9BCrohjHoQYRET0OLw3/G1duwB\nN9lfXAzUF1QCEI3fzqvuveFOY799mRjBKKGsAYZ/f2aqVseKKuT10U2QW0Qv3ulg\nQBxXtaybB/3zsxLaT4z/ceH0MU2TNwRpzxggpBkCgYEAhYhjZObIaks+3BcEKsqH\nKcJraZmk1M/hKW1eK/+xZp6rahRF22wENoKHzyTZ5aIdTOC/OTqxYjNW/Go1z9BQ\nmHzjjIBg6bBg58X+Yg+ia6UASqIqB729YzQ5kw76MJIfk1NPlS69ErFNVp5OimWI\n3uPZAdmg1hVTAu4CxPb/q8Y=\n-----END PRIVATE KEY-----\n",
    google_service_key_id: "a395b87766db78090ff8524587c907888455a037",
    paypal_client_id: "AXbza-5lYAdIdJSXtnpcA413_mSl8_yyvQJZu7svTrOMurNo1ZBl_nEIKKgFQUC6CQayzLv7lJYfCWuT",
    paypal_client_secret: "EHBr_kWP5hbNrjyHiP2mtjkAX8t8OEVcVoA_aAnmV3O4sjFT3T4gBoNeRNvVY_L-44RbtIqXcm0kcOE4",
    paypal_sandbox_client_id: "Ad3jFFyEjn7emRQi69SaLndh6-grUhIroMMEsxZ9ooj9Yw7Gb_SxaZKI9MhuvFwrW4KM1U0WreOCSfKp",
    paypal_sandbox_client_secret: "EByzzqdvcCMGpLXbToJE-_slG6jW5JVu2p00gSQxG5Ib6VSGXlAQtgdTxS14kVISpmvGRx2JP57CCNFu",
    paypal_sandbox_url: "https://api.sandbox.paypal.com",
    paypal_production_url: "https://api.paypal.com",
    openAi_api_key: "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",
    account_salt: "v83*m))/gx%9K3m#v9!2m*h)5'hs",
    twilio_account_sid: "",
    twilio_auth_token: "",
    container_hub_api_key: "d1da66b17cc04985a1a1ef11e73f37440ee5cb41c2a4443db96208f1876c9055f8f3ebb4ca034b0e802de4fe80308328",
    dev_email: "it@abcchs.com.au",
    live_email: "service@abcchs.com.au"
}

if (config.dev_mode) {
    config.web_url = "http://localhost:3000/";
}

config.container_hub_url = config.dev_mode ? "https://localhost:44357/api/ecommerce" : "https://containerhub.com.au/api/ecommerce";

export default config;